import React from 'react'
import { convertToCamelCase } from "../helper/convertToCamelCase";
import { useTranslate } from "./TranslationText";
import PillBtn from './PillBtn';
import { getFileName } from '../helper/getFileName';
import { formatDateTimeToString } from '../helper/formatDateTimeToString';
import { setReturnTicket } from '../helper/pageFilterPersistence';

const BaseURL = process.env.REACT_APP_BASE_URL;
const SHOWS_TICKET_KEY = "shows_return_from_details";


export default function ShowCard({ item, i }) {
    const { translate } = useTranslate();

    return (
        <div className={'col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 mb-main'}>
            <div className='bg-white row mx-0 rtl   p-main border-15 p-3 h-100' >
                <div className='col-lg-4 col-md-4 col-sm-12 col-12 ps-sm-0'>
                    <img
                        className='w-100 border-15'
                        src={item.logo}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `${BaseURL}/assets/img/horseauction.png`;
                        }}
                        alt={getFileName(item?.logo)} />
                </div>
                <div className='col-lg-8 col-md-8 col-sm-12 col-12 pe-sm-0'>

                    {item.showName !== null && item.showName !== "" && (
                        <div className='showNewTitle'>
                            {item.showName}
                        </div>
                    )}
                    <div className='showNewDetials'>
                        <div className='showNewRank showNewStartDate '>
                            <div>
                                <i className=" fa fa-trophy " style={{ color: 'var(--mainGold)' }} ></i> {item.showRank}
                            </div>
                            <div>
                                <i className=" fa-solid fa-location-dot" style={{ color: 'var(--mainGold)' }} ></i>{translate(`web.${convertToCamelCase(item.cityName)}`, item.cityName)}
                            </div>
                        </div>

                        <div className='showNewRank showNewStartDate '>
                            <div>
                                <i className=" fa fa-calendar" style={{ color: 'var(--mainGold)' }}></i>{translate("web.startDate", "Start Date")}:
                            </div>
                            <div>
                                {formatDateTimeToString(item?.startDateObject)} 
                            </div>
                        </div>
                        <div className='showNewLocation showNewStartDate'>
                            <div>
                                <i className=" fa fa-calendar " style={{ color: 'var(--mainGold)' }}></i>{translate("web.endDate", "End Date")}:
                            </div>
                            <div>
                                {formatDateTimeToString(item?.endDateObject)}
                            </div>
                        </div>
                        {(new Date(item?.startDateObject) > new Date()) && (!!item?.registerStartDateObject) && (item?.registerEndDateObject) && <>
                            <div className='showNewRank showNewStartDate'>
                                <div>
                                    <i className=" fa fa-calendar" style={{ color: 'var(--mainGold)' }} ></i>{translate("web.regStartDate", "Reg Start Date")}:
                                </div>
                                <div>
                                    {formatDateTimeToString(item?.registerStartDateObject)}
                                </div>
                            </div>
                            <div className='showNewLocation showNewStartDate'>
                                <div>
                                    <i className=" fa fa-calendar " style={{ color: 'var(--mainGold)' }} ></i>{translate("web.regEndDate", "Reg End Date")}:
                                </div>
                                <div>
                                    {formatDateTimeToString(item?.registerEndDateObject)}
                                </div>
                            </div>
                        </>
                        }
                    </div>
                </div>
                <div className='col-12 px-0  mx-0 row mt-3 rtl'>
                    {item.haveTermsAndConditions &&
                        <div className='col-lg-6 col-md-12 col-sm-12 col-12 ms-auto mb-lg-0 mb-sm-2 mb-2 ps-lg-0' >
                            <PillBtn
                                isRed={false}
                                isNoMargin
                                text={translate("web.termsAndConditions", "termsAndConditions")}
                                key={'termsAndCondition' + i}
                                routeName={`/SingleTermsAndConditionsShowPage?id=${item.id}`}
                                onClick={() => setReturnTicket(SHOWS_TICKET_KEY)}
                            />
                        </div>
                    }
                    <div className='col-lg-6 col-md-12 col-sm-12 col-12 ms-auto mb-sm-0 mb-2 pe-lg-0'>
                        <PillBtn
                            isRed={true}
                            isNoMargin
                            text={translate("web.viewDetails", "View Details")}
                            key={'viewDetailsShow' + i}
                            routeName={`/showdetails?id=${item.id}`}
                            onClick={() => setReturnTicket(SHOWS_TICKET_KEY)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
